export function convertToCsv(array: string[][]) {
  // build simple multi-line string from array
  const csvContent = array.map((row: string[]) => row.join(',')).join('\n');

  // convert to csv blob
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const objectUrl = URL.createObjectURL(blob);

  return objectUrl;
}

// export const downloadFile = (dataUrl: string, filename: string) => {
export const downloadFile = (dataUrl: string, filename: string) => {
  // build new `a` element with proper attributes
  const downloadCsvLink = document.createElement('a');
  downloadCsvLink.href = dataUrl;
  downloadCsvLink.download = filename;

  // append to document, click, remove right away so layout doesn't change
  document.body.appendChild(downloadCsvLink);
  downloadCsvLink.click();
  document.body.removeChild(downloadCsvLink);
};
